"use client"

import { Card } from "antd"
import React, { useState, useEffect } from "react"
//import { useCart } from "@/hooks/useCart"

export default function MinimalTemplate() {
  const [cart, setCart] = useState(() => {
const savedCart = localStorage.getItem("cartObj");
return savedCart ? JSON.parse(savedCart) : { items: [], total: 0, paid: 0, salesRepName: "" };
});

const currenciesList = [
    {
      currSymbol: "$",
      symbolRightSide: "N",
    },
  ];
  const pricePrecision = 2;

useEffect(() => {
    const intervalId = setInterval(() => {
      const savedCart = localStorage.getItem("cartObj");
      if (savedCart) {
        setCart(JSON.parse(savedCart));
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);
  
  return (
    <div
      style={{
        //height: "100vh",
        background: "#FFFFFF",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          //maxWidth: 500,
          width: "100%",
          display: "grid",
          gridTemplateColumns: "1fr",
          padding: "10px",
          gap: 10,
        }}
        className="lg:grid-cols-2"
      >
        {/* Left Side - Welcome */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <h1
            style={{
              fontSize: 40,
              fontWeight: 300,
              color: "#1F2937",
              marginBottom: 5,
            }}
          >
            Welcome
          </h1>
          <div style={{ fontSize: 60 }}>☕</div>
          <p
            style={{
              fontSize: 24,
              color: "#4B5563",
              fontWeight: 200,
            }}
          >
            Fresh • Quality • Service
          </p>
        </div>

        {/* Right Side - Order */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Card
            title="Your Order"
            headStyle={{
              fontSize: 30,
              fontWeight: 300,
              color: "#1F2937",
              textAlign: "center",
              borderBottom: "none",
              marginBottom: 5,
            }}
            style={{
              border: "none",
              boxShadow: "none",
              background: "transparent",
            }}
            bodyStyle={{ padding: 0 }}
          >
            {cart.items.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  //padding: "48px 0",
                }}
              >
                <div
                  style={{
                    fontSize: 60,
                    color: "#D1D5DB",
                    //marginBottom: 16,
                  }}
                >
                  🛒
                </div>
                <p
                  style={{
                    fontSize: 20,
                    color: "#6B7280",
                    fontWeight: 300,
                  }}
                >
                  No items yet
                </p>
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                {cart.items.map((item) => (
                  <div
                    key={item.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "2px 0",
                      borderBottom: "1px solid #E5E7EB",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                      <div
                        style={{
                          width: 16,
                          height: 16,
                          background: "#1F2937",
                          borderRadius: "10%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#FFFFFF",
                          fontSize: 12,
                        }}
                      >
                        {item.quantity}
                      </div>
                      <span
                        style={{
                          fontSize: 20,
                          fontWeight: 300,
                          color: "#1F2937",
                        }}
                      >
                        {item.name}
                      </span>
                    </div>
                    <span
                      style={{
                        fontSize: 20,
                        fontWeight: 300,
                        color: "#1F2937",
                      }}
                    >
                     {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                          {parseFloat(item.price * item.quantity).toFixed(pricePrecision)}
                          {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                    </span>
                  </div>
                ))}

                <div
                  style={{
                    //paddingTop: 24,
                    borderTop: "2px solid #1F2937",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 24,
                        fontWeight: 300,
                        color: "#1F2937",
                      }}
                    >
                      Total
                    </span>
                    <span
                      style={{
                        fontSize: 30,
                        fontWeight: 300,
                        color: "#1F2937",
                      }}
                    >
                      ${cart.total.toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </Card>
        </div>
      </div>
    </div>
  )
}